// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAA2KwMTruSQJEby8QgQjkc2c_5BcKrCdA",
  authDomain: "kinatrip-d8a3d.firebaseapp.com",
  databaseURL:
    "https://kinatrip-d8a3d-default-rtdb.firebaseio.com",
  projectId: "kinatrip-d8a3d",
  storageBucket:
    "kinatrip-d8a3d.firebasestorage.app",
  messagingSenderId: "1087808704430",
  appId:
    "1:1087808704430:web:dd5a9c94a210681516023f",
};

// Initialize Firebase once
const app = initializeApp(firebaseConfig);

// Export initialized services
export const auth = getAuth(app);
export const db = getDatabase(app);
export const storage = getStorage(app);